import React from 'react';
import { motion } from 'framer-motion';
import { isAndroid, isIOS } from 'react-device-detect';

const AppBanner = ({ onClose, isNonSafariIOS }) => {
  const getBannerContent = () => {
    // iOS su browser NON Safari (Chrome, Firefox, ecc.)
    if (isNonSafariIOS || (isIOS && !isSafari())) {
      return {
        title: 'WanderBuddy',
        subtitle: 'Apri in Safari per funzionalità complete',
        actionText: 'APP STORE',
        actionUrl: 'https://apps.apple.com/app/id6737308693'
      };
    }
    
    if (isAndroid) {
      return {
        title: 'WanderBuddy',
        subtitle: 'Disponibile su iOS, Android in arrivo',
        actionText: 'WAITLIST',
        actionUrl: '/waitlist'
      };
    }
    
    // Desktop/Altri browser
    return {
      title: 'WanderBuddy',
      subtitle: 'Il tuo compagno di viaggio AI',
      actionText: 'SCOPRI',
      actionUrl: 'https://apps.apple.com/app/id6737308693'
    };
  };
  
  // Funzione helper per rilevare Safari
  const isSafari = () => {
    const ua = navigator.userAgent.toLowerCase();
    // Safari contiene "safari" ma NON "chrome" o "crios" (Chrome iOS)
    return ua.indexOf('safari') !== -1 && 
           ua.indexOf('chrome') === -1 && 
           ua.indexOf('crios') === -1 &&
           ua.indexOf('fxios') === -1 && // Firefox iOS
           ua.indexOf('edgios') === -1;  // Edge iOS
  };

  const content = getBannerContent();

  return (
    <motion.div 
      className="app-banner"
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -100, opacity: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      <div className="banner-content">
        <div className="banner-icon">W</div>
        
        <div className="banner-text">
          <div className="banner-title">{content.title}</div>
          <div className="banner-subtitle">{content.subtitle}</div>
        </div>
        
        <motion.a 
          href={content.actionUrl}
          className="banner-action"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={(e) => {
            if (content.actionUrl === '/waitlist') {
              e.preventDefault();
              window.location.href = '/waitlist';
            }
          }}
        >
          {content.actionText}
        </motion.a>
        
        <motion.button 
          className="banner-close"
          onClick={onClose}
          whileHover={{ scale: 1.1, rotate: 90 }}
          whileTap={{ scale: 0.9 }}
          aria-label="Chiudi banner"
        >
          ×
        </motion.button>
      </div>
    </motion.div>
  );
};

export default AppBanner;
